module.exports = __webpack_public_path__ + "img/underIDC.9a210bbd.png";